(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-battery-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let bkfBodyScrollLockCount = 0;

    const lockBodyScrollForBkfDrag = () => {
      bkfBodyScrollLockCount += 1;
      if (bkfBodyScrollLockCount === 1) document.body.classList.add('bkf-dnd-drag-active');
    };

    const unlockBodyScrollForBkfDrag = () => {
      bkfBodyScrollLockCount = Math.max(0, bkfBodyScrollLockCount - 1);
      if (bkfBodyScrollLockCount === 0) document.body.classList.remove('bkf-dnd-drag-active');
    };

    /* iOS Safari often emits pointercancel while the finger is still moving; freeze scroll + bridge touch events */
    let iosViewportLockDepth = 0;
    let iosViewportLockScrollY = 0;

    const lockIosViewportForDrag = () => {
      if (iosViewportLockDepth === 0) {
        iosViewportLockScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${iosViewportLockScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
      iosViewportLockDepth += 1;
    };

    const unlockIosViewportForDrag = () => {
      iosViewportLockDepth = Math.max(0, iosViewportLockDepth - 1);
      if (iosViewportLockDepth > 0) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      window.scrollTo(0, iosViewportLockScrollY);
    };

    const SECTION_SELECTOR = '[data-battery-key-features]';
    const STRIP_SELECTOR = '[data-bkf-dnd-strip]';
    const ITEM_SELECTOR = '[data-bkf-dnd-item]';
    const DROPZONE_WRAPPER_SELECTOR = '[data-bkf-dropzone]';
    const DROPZONE_STRIP_SELECTOR = '[data-bkf-dropzone-strip]';

    const BODY_SYNC_CLASS = 'bkf-theme-sync';
    const MAIN_SELECTOR = '#MainContent';

    const initialized = new WeakSet();

    const setLiveMessage = (sectionEl, message) => {
      const live = sectionEl.querySelector('#DndLiveRegion-0');
      if (!live) return;
      live.textContent = message;
    };

    const initDnd = (sectionEl) => {
      const main = document.querySelector(MAIN_SELECTOR);
      const strip = sectionEl.querySelector(STRIP_SELECTOR);
      const dropWrapper = sectionEl.querySelector(DROPZONE_WRAPPER_SELECTOR);
      const dropStrip = sectionEl.querySelector(DROPZONE_STRIP_SELECTOR);
      const emptyState = sectionEl.querySelector('[data-bkf-empty-state]');
      if (!main || !strip || !dropWrapper || !dropStrip) return;
      if (initialized.has(strip)) return;
      initialized.add(strip);

      const itemsIn = (el) => Array.from(el.querySelectorAll(ITEM_SELECTOR));
      const dropCount = () => itemsIn(dropStrip).length;
      const toggleClass = (el, className, force) => el.classList.toggle(className, force);

      const setDropVisible = (visible) => {
        dropWrapper.hidden = !visible;
      };

      const updateTopStripLayout = () => {
        const hasItems = itemsIn(strip).length > 0;
        toggleClass(strip, 'w-full', hasItems);
        toggleClass(strip, 'min-h-[176px]', hasItems);
      };

      const applyItemState = (item, isDeactivated) => {
        toggleClass(item, 'is-deactivated', isDeactivated);
        item.style.backgroundColor = isDeactivated
          ? 'var(--bkf-demo-item-deactivated-bg)'
          : 'var(--bkf-demo-item-bg)';
      };

      const updateItemStates = () => {
        for (const item of itemsIn(strip)) {
          applyItemState(item, false);
        }
        for (const item of itemsIn(dropStrip)) {
          applyItemState(item, true);
        }
      };

      const updateEmptyState = () => {
        if (!emptyState) return;
        emptyState.hidden = itemsIn(strip).length > 0;
      };

      const updateSync = () => {
        const shouldSync = dropCount() > 0;
        toggleClass(document.body, BODY_SYNC_CLASS, shouldSync);
        updateTopStripLayout();
        updateItemStates();
        updateEmptyState();
      };

      setDropVisible(dropCount() > 0);
      updateSync();

      let bodyScrollLocked = false;
      let touchBridgeActive = false;
      let bridgeActiveTouchId = null;
      let iosViewportLockedForDrag = false;
      let pointerId = null;
      let activeItem = null;
      let placeholder = null;
      let ghost = null;
      let startRect = null;
      let startOrder = null;
      let grabMode = false;
      let pointerOffsetX = 0;
      let pointerOffsetY = 0;

      const DRAG_THRESHOLD_PX = 10;
      let pendingPointer = null;
      let pendingTouchViewportLocked = false;

      const pendingListenerOpts = { capture: true, passive: false };
      const pendingTouchBlockOpts = { capture: true, passive: false };

      const releasePointerCaptureIfHeld = (el, id) => {
        if (!el || id == null) return;
        try {
          if (typeof el.hasPointerCapture === 'function' && !el.hasPointerCapture(id)) return;
          el.releasePointerCapture(id);
        } catch {
          /* pointer may already be released */
        }
      };

      const onPendingTouchMoveBlock = (e) => {
        if (!pendingPointer) return;
        if (!e.cancelable) return;
        e.preventDefault();
      };

      const removePendingTouchMoveBlock = () => {
        document.removeEventListener('touchmove', onPendingTouchMoveBlock, pendingTouchBlockOpts);
      };

      const clearPendingTouchGesture = () => {
        removePendingTouchMoveBlock();
        document.documentElement.classList.remove('bkf-dnd-gesture-touch');
        if (pendingTouchViewportLocked) {
          unlockIosViewportForDrag();
          pendingTouchViewportLocked = false;
        }
      };

      const removePendingWindowListeners = () => {
        window.removeEventListener('pointermove', onPendingPointerMove, pendingListenerOpts);
        window.removeEventListener('pointerup', onPendingPointerUp, pendingListenerOpts);
        window.removeEventListener('pointercancel', onPendingPointerCancel, pendingListenerOpts);
      };

      const toggleItemBetweenZones = (item) => {
        const parent = item.parentElement;
        if (parent === strip) {
          if (dropCount() === 0) setDropVisible(true);
          dropStrip.appendChild(item);
          setLiveMessage(sectionEl, 'Moved to deactivated area.');
        } else if (parent === dropStrip) {
          if (emptyState) strip.insertBefore(item, emptyState);
          else strip.appendChild(item);
          setLiveMessage(sectionEl, 'Moved to active area.');
        } else {
          return;
        }
        item.focus();
        setDropVisible(dropCount() > 0);
        updateSync();
      };

      const onPendingPointerMove = (e) => {
        if (!pendingPointer || e.pointerId !== pendingPointer.pointerId) return;
        if (e.pointerType === 'touch') e.preventDefault();
        const dx = e.clientX - pendingPointer.x0;
        const dy = e.clientY - pendingPointer.y0;
        if (Math.hypot(dx, dy) < DRAG_THRESHOLD_PX) return;
        e.preventDefault();
        const item = pendingPointer.item;
        removePendingWindowListeners();
        removePendingTouchMoveBlock();
        pendingPointer = null;
        startPointerDrag(e, item);
      };

      const onPendingPointerUp = (e) => {
        if (!pendingPointer || e.pointerId !== pendingPointer.pointerId) return;
        e.preventDefault();
        const item = pendingPointer.item;
        removePendingWindowListeners();
        pendingPointer = null;
        releasePointerCaptureIfHeld(item, e.pointerId);
        clearPendingTouchGesture();
        toggleItemBetweenZones(item);
      };

      const onPendingPointerCancel = (e) => {
        if (!pendingPointer || e.pointerId !== pendingPointer.pointerId) return;
        const item = pendingPointer.item;
        removePendingWindowListeners();
        pendingPointer = null;
        releasePointerCaptureIfHeld(item, e.pointerId);
        clearPendingTouchGesture();
      };

      const buildPlaceholder = (rect) => {
        const ph = document.createElement('div');
        ph.setAttribute('data-bkf-placeholder', '');
        ph.style.width = `${rect.width}px`;
        ph.style.height = `${rect.height}px`;
        ph.style.flex = `0 0 ${rect.width}px`;
        return ph;
      };

      const buildGhost = (item, rect) => {
        const clone = item.cloneNode(true);
        const computedItem = getComputedStyle(item);
        const itemCap = item.querySelector('div');
        const cloneCap = clone.querySelector('div');

        clone.setAttribute('aria-hidden', 'true');
        clone.style.position = 'fixed';
        clone.style.left = `${rect.left}px`;
        clone.style.top = `${rect.top}px`;
        clone.style.width = `${rect.width}px`;
        clone.style.height = `${rect.height}px`;
        clone.style.zIndex = '9999';
        clone.style.pointerEvents = 'none';
        clone.style.transform = 'translate3d(0,0,0)';
        clone.style.transition = 'none';
        clone.style.animation = 'none';
        clone.style.willChange = 'left, top';
        clone.style.opacity = '0.9';
        clone.style.cursor = 'grabbing';

        // Keep original visual colors when clone moves outside section scope.
        clone.style.backgroundColor = computedItem.backgroundColor;
        clone.style.borderColor = computedItem.borderColor;

        if (itemCap && cloneCap) {
          const computedCap = getComputedStyle(itemCap);
          cloneCap.style.backgroundColor = computedCap.backgroundColor;
          cloneCap.style.borderColor = computedCap.borderColor;
        }

        return clone;
      };

      const dragDocListenerOpts = { capture: true, passive: false };
      const touchBridgeOpts = { capture: true, passive: false };

      const removeTouchBridgeListeners = () => {
        document.removeEventListener('touchmove', onTouchMoveBridge, touchBridgeOpts);
        document.removeEventListener('touchend', onTouchEndBridge, touchBridgeOpts);
        document.removeEventListener('touchcancel', onTouchCancelBridge, touchBridgeOpts);
      };

      const removeDragDocumentListeners = () => {
        document.removeEventListener('pointermove', onPointerMove, dragDocListenerOpts);
        document.removeEventListener('pointerup', endPointerDrag, dragDocListenerOpts);
        document.removeEventListener('pointercancel', cancelPointerDrag, dragDocListenerOpts);
        if (activeItem) activeItem.removeEventListener('lostpointercapture', onLostPointerCapture);
      };

      const onLostPointerCapture = (e) => {
        if (touchBridgeActive) return;
        if (!activeItem || e.pointerId !== pointerId) return;
        cancelPointerDrag(e);
      };

      const cleanup = () => {
        if (touchBridgeActive) {
          removeTouchBridgeListeners();
          touchBridgeActive = false;
          bridgeActiveTouchId = null;
        }
        if (iosViewportLockedForDrag) {
          unlockIosViewportForDrag();
          iosViewportLockedForDrag = false;
        }
        // Remove listeners before releasing capture so `lostpointercapture` cannot re-enter handlers.
        removeDragDocumentListeners();
        if (pointerId !== null && activeItem) {
          try {
            activeItem.releasePointerCapture(pointerId);
          } catch {
            /* pointer may already be released */
          }
        }
        ghost?.remove();
        placeholder?.remove();
        ghost = null;
        placeholder = null;
        pointerId = null;
        activeItem = null;
        startRect = null;
        pointerOffsetX = 0;
        pointerOffsetY = 0;
        sectionEl.classList.remove('is-dragging');
        if (bodyScrollLocked) {
          unlockBodyScrollForBkfDrag();
          bodyScrollLocked = false;
        }
        document.documentElement.classList.remove('bkf-dnd-gesture-touch');
      };

      const snapshotOrder = () => ({
        strip: itemsIn(strip),
        drop: itemsIn(dropStrip),
      });

      const restoreOrder = (snap) => {
        strip.innerHTML = '';
        dropStrip.innerHTML = '';
        for (const el of snap.strip) strip.appendChild(el);
        for (const el of snap.drop) dropStrip.appendChild(el);
        if (emptyState) strip.appendChild(emptyState);
      };

      const closestInsertBefore = (containerEl, clientX) => {
        const list = itemsIn(containerEl).filter((el) => el !== activeItem && el !== placeholder);
        let closest = null;
        let closestDist = Infinity;

        for (const el of list) {
          const r = el.getBoundingClientRect();
          const center = r.left + r.width / 2;
          const dist = Math.abs(clientX - center);
          if (dist < closestDist) {
            closestDist = dist;
            closest = el;
          }
        }

        if (!closest) return null;
        const r = closest.getBoundingClientRect();
        return clientX < r.left + r.width / 2 ? closest : closest.nextElementSibling;
      };

      const targetContainerForPoint = (x, y) => {
        const intersects = (a, b) =>
          a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
        const overlapArea = (a, b) => {
          const width = Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left));
          const height = Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
          return width * height;
        };

        const ghostRect = ghost ? ghost.getBoundingClientRect() : null;
        const sr = strip.getBoundingClientRect();

        // 1) Cursor-first hit testing for predictable behavior.
        if (x >= sr.left && x <= sr.right && y >= sr.top && y <= sr.bottom) return strip;

        if (!dropWrapper.hidden) {
          const dw = dropWrapper.getBoundingClientRect();
          const dz = dropStrip.getBoundingClientRect();

          if (
            (x >= dw.left && x <= dw.right && y >= dw.top && y <= dw.bottom) ||
            (x >= dz.left && x <= dz.right && y >= dz.top && y <= dz.bottom)
          ) {
            return dropStrip;
          }

          // 2) Fallback by overlap area: choose the stronger overlap.
          if (ghostRect) {
            const overlapStrip = intersects(ghostRect, sr) ? overlapArea(ghostRect, sr) : 0;
            const overlapDropWrapper = intersects(ghostRect, dw) ? overlapArea(ghostRect, dw) : 0;
            const overlapDropStrip = intersects(ghostRect, dz) ? overlapArea(ghostRect, dz) : 0;
            const overlapDrop = Math.max(overlapDropWrapper, overlapDropStrip);

            if (overlapStrip > 0 || overlapDrop > 0) {
              return overlapStrip >= overlapDrop ? strip : dropStrip;
            }
          }
        }

        if (ghostRect && intersects(ghostRect, sr)) return strip;

        return placeholder?.parentElement || strip;
      };

      const applyDragFromClient = (clientX, clientY) => {
        if (!activeItem || !ghost || !startRect) return;
        ghost.style.left = `${clientX - pointerOffsetX}px`;
        ghost.style.top = `${clientY - pointerOffsetY}px`;
        const target = targetContainerForPoint(clientX, clientY);
        const before = closestInsertBefore(target, clientX);
        if (before) target.insertBefore(placeholder, before);
        else target.appendChild(placeholder);
      };

      const finalizeDropAt = (clientX, clientY) => {
        if (!activeItem) return;
        const releaseTarget = targetContainerForPoint(clientX, clientY);
        const releaseBefore = closestInsertBefore(releaseTarget, clientX);
        if (releaseBefore) releaseTarget.insertBefore(placeholder, releaseBefore);
        else releaseTarget.appendChild(placeholder);

        placeholder?.parentElement?.insertBefore(activeItem, placeholder);
        activeItem.style.visibility = '';
        activeItem.classList.remove('cursor-grabbing');
        cleanup();

        setLiveMessage(sectionEl, 'Dropped.');
        setDropVisible(dropCount() > 0);
        updateSync();
      };

      const abortActiveDrag = () => {
        if (!activeItem) return;
        if (startOrder) restoreOrder(startOrder);
        activeItem.style.visibility = '';
        cleanup();
        setLiveMessage(sectionEl, 'Cancelled.');
        setDropVisible(dropCount() > 0);
        updateSync();
      };

      const onTouchMoveBridge = (e) => {
        if (!touchBridgeActive || !activeItem || !ghost) return;
        let touch =
          bridgeActiveTouchId != null
            ? [...e.touches].find((t) => t.identifier === bridgeActiveTouchId)
            : null;
        if (!touch && e.touches.length === 1) {
          touch = e.touches[0];
          bridgeActiveTouchId = touch.identifier;
        }
        if (!touch) return;
        e.preventDefault();
        applyDragFromClient(touch.clientX, touch.clientY);
      };

      const onTouchEndBridge = (e) => {
        if (!touchBridgeActive || !activeItem) return;
        if (!e.changedTouches?.length) return;
        const touch =
          bridgeActiveTouchId != null
            ? [...e.changedTouches].find((t) => t.identifier === bridgeActiveTouchId)
            : e.changedTouches[0];
        if (!touch) return;
        if (bridgeActiveTouchId != null) {
          const ended = [...e.changedTouches].some((t) => t.identifier === bridgeActiveTouchId);
          if (!ended) return;
        }
        e.preventDefault();
        finalizeDropAt(touch.clientX, touch.clientY);
      };

      const onTouchCancelBridge = (e) => {
        if (!touchBridgeActive || !activeItem) return;
        if (!e.changedTouches?.length) return;
        const touch =
          bridgeActiveTouchId != null
            ? [...e.changedTouches].find((t) => t.identifier === bridgeActiveTouchId)
            : e.changedTouches[0];
        if (!touch) return;
        if (bridgeActiveTouchId != null) {
          const cancelled = [...e.changedTouches].some((t) => t.identifier === bridgeActiveTouchId);
          if (!cancelled) return;
        }
        e.preventDefault();
        abortActiveDrag();
      };

      const startPointerDrag = (e, item) => {
        pointerId = e.pointerId;
        activeItem = item;
        startRect = item.getBoundingClientRect();
        pointerOffsetX = e.clientX - startRect.left;
        pointerOffsetY = e.clientY - startRect.top;
        startOrder = snapshotOrder();

        placeholder = buildPlaceholder(startRect);
        ghost = buildGhost(item, startRect);
        document.body.appendChild(ghost);

        item.style.visibility = 'hidden';
        item.classList.add('cursor-grabbing');
        item.parentElement?.insertBefore(placeholder, item);
        sectionEl.classList.add('is-dragging');

        // First interaction: if drop is empty, move immediately into it + show wrapper
        if (dropCount() === 0) {
          setDropVisible(true);
          dropStrip.appendChild(placeholder);
        }

        setLiveMessage(sectionEl, 'Picked up. Drag to reorder.');
        item.setPointerCapture(pointerId);

        touchBridgeActive = e.pointerType === 'touch';
        bridgeActiveTouchId = null;
        if (touchBridgeActive) {
          if (!pendingTouchViewportLocked) {
            lockIosViewportForDrag();
          }
          iosViewportLockedForDrag = true;
          pendingTouchViewportLocked = false;
          document.documentElement.classList.add('bkf-dnd-gesture-touch');
          document.addEventListener('touchmove', onTouchMoveBridge, touchBridgeOpts);
          document.addEventListener('touchend', onTouchEndBridge, touchBridgeOpts);
          document.addEventListener('touchcancel', onTouchCancelBridge, touchBridgeOpts);
        }

        lockBodyScrollForBkfDrag();
        bodyScrollLocked = true;

        document.addEventListener('pointermove', onPointerMove, dragDocListenerOpts);
        document.addEventListener('pointerup', endPointerDrag, dragDocListenerOpts);
        document.addEventListener('pointercancel', cancelPointerDrag, dragDocListenerOpts);
        item.addEventListener('lostpointercapture', onLostPointerCapture);

        updateSync();
      };

      const onPointerMove = (e) => {
        if (!activeItem || e.pointerId !== pointerId || !ghost || !startRect) return;
        e.preventDefault();
        applyDragFromClient(e.clientX, e.clientY);
      };

      const endPointerDrag = (e) => {
        if (!activeItem || e.pointerId !== pointerId) return;
        e.preventDefault();
        finalizeDropAt(e.clientX, e.clientY);
      };

      const cancelPointerDrag = (e) => {
        if (touchBridgeActive && e.type === 'pointercancel') return;
        if (!activeItem || e.pointerId !== pointerId) return;
        e.preventDefault();
        abortActiveDrag();
      };

      const attachPointer = (rootEl) => {
        rootEl.addEventListener('pointerdown', (e) => {
          const item = e.target.closest(ITEM_SELECTOR);
          if (!item) return;
          if (e.button !== 0) return;
          if (grabMode) return;
          e.preventDefault();
          pendingPointer = {
            pointerId: e.pointerId,
            item,
            x0: e.clientX,
            y0: e.clientY,
          };
          try {
            item.setPointerCapture(e.pointerId);
          } catch {
            /* ignore */
          }
          if (e.pointerType === 'touch') {
            lockIosViewportForDrag();
            pendingTouchViewportLocked = true;
            document.documentElement.classList.add('bkf-dnd-gesture-touch');
            document.addEventListener('touchmove', onPendingTouchMoveBlock, pendingTouchBlockOpts);
          }
          window.addEventListener('pointermove', onPendingPointerMove, pendingListenerOpts);
          window.addEventListener('pointerup', onPendingPointerUp, pendingListenerOpts);
          window.addEventListener('pointercancel', onPendingPointerCancel, pendingListenerOpts);
        });
      };

      attachPointer(strip);
      attachPointer(dropStrip);

      const moveByKeyboard = (dir) => {
        const item = document.activeElement?.closest?.(ITEM_SELECTOR);
        if (!item) return;
        const parent = item.parentElement;
        if (!parent || (parent !== strip && parent !== dropStrip)) return;

        const sib = itemsIn(parent);
        const idx = sib.indexOf(item);
        const next = dir === 'left' ? idx - 1 : idx + 1;
        if (next < 0 || next >= sib.length) return;

        const ref = dir === 'left' ? sib[next] : sib[next].nextElementSibling;
        parent.insertBefore(item, ref);
        item.focus();
        setLiveMessage(sectionEl, 'Moved.');
      };

      const onKeydown = (e) => {
        const item = e.target.closest(ITEM_SELECTOR);
        if (!item) return;

        if (e.code === 'Space') {
          e.preventDefault();
          if (!grabMode) {
            grabMode = true;
            startOrder = snapshotOrder();

            if (dropCount() === 0) {
              setDropVisible(true);
              dropStrip.appendChild(item);
              item.focus();
            }

            item.classList.add('ring-2', 'ring-black/20');
            setLiveMessage(sectionEl, 'Picked up. Use arrow keys to move, space to drop, escape to cancel.');
            updateSync();
          } else {
            grabMode = false;
            item.classList.remove('ring-2', 'ring-black/20');
            setLiveMessage(sectionEl, 'Dropped.');
            setDropVisible(dropCount() > 0);
            updateSync();
          }
          return;
        }

        if (!grabMode) return;

        if (e.code === 'Escape') {
          e.preventDefault();
          grabMode = false;
          item.classList.remove('ring-2', 'ring-black/20');
          if (startOrder) restoreOrder(startOrder);
          setLiveMessage(sectionEl, 'Cancelled.');
          setDropVisible(dropCount() > 0);
          updateSync();
          return;
        }

        if (e.code === 'ArrowLeft') {
          e.preventDefault();
          moveByKeyboard('left');
        }
        if (e.code === 'ArrowRight') {
          e.preventDefault();
          moveByKeyboard('right');
        }
      };

      strip.addEventListener('keydown', onKeydown);
      dropStrip.addEventListener('keydown', onKeydown);
    };

    const init = () => {
      for (const sectionEl of document.querySelectorAll(SECTION_SELECTOR)) {
        initDnd(sectionEl);
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:section:reorder', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-blog-custom-posts"] && !Shopify.designMode) return;
  try {
    
  class SectionBlogCustomPosts {
    constructor(root) {
      this.root = root;
      this.filters = Array.from(this.root.querySelectorAll('[data-sbc-filter]'));
      this.posts = Array.from(this.root.querySelectorAll('[data-sbc-post]'));
      this.grid = this.root.querySelector('[data-sbc-grid]');

      this.#bindEvents();
      this.#applyDefaultFilter();
    }

    #bindEvents() {
      for (const btn of this.filters) {
        btn.addEventListener('click', () => {
          const key = btn.dataset.sbcKey || 'all';
          this.#setActiveFilter(key);
          this.#applyFilter(key);
        });
      }
    }

    #applyDefaultFilter() {
      const active = this.filters.find((btn) => btn.getAttribute('aria-pressed') === 'true');
      const key = active?.dataset?.sbcKey || 'all';

      this.#setActiveFilter(key);
      this.#applyFilter(key);
    }

    #setActiveFilter(key) {
      for (const btn of this.filters) {
        const isActive = (btn.dataset.sbcKey || 'all') === key;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    }

    #applyFilter(key) {
      for (const post of this.posts) {
        const postKey = post.dataset.sbcKey || '';
        const shouldShow = key === 'all' || postKey === key;

        post.hidden = !shouldShow;
      }
    }
  }

  (() => {
    const roots = document.querySelectorAll('.section-blog-custom-posts');
    for (const root of roots) new SectionBlogCustomPosts(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-distributor-locations"] && !Shopify.designMode) return;
  try {
    
  class SectionBlogCustomPosts {
    constructor(root) {
      this.root = root;
      this.filters = Array.from(this.root.querySelectorAll('[data-sbc-filter]'));
      this.posts = Array.from(this.root.querySelectorAll('[data-sbc-post]'));
      this.grid = this.root.querySelector('[data-sbc-grid]');

      this.#bindEvents();
      this.#applyDefaultFilter();
    }

    #bindEvents() {
      for (const btn of this.filters) {
        btn.addEventListener('click', () => {
          const key = btn.dataset.sbcKey || 'all';
          this.#setActiveFilter(key);
          this.#applyFilter(key);
        });
      }
    }

    #applyDefaultFilter() {
      const active = this.filters.find((btn) => btn.getAttribute('aria-pressed') === 'true');
      const key = active?.dataset?.sbcKey || 'all';

      this.#setActiveFilter(key);
      this.#applyFilter(key);
    }

    #setActiveFilter(key) {
      for (const btn of this.filters) {
        const isActive = (btn.dataset.sbcKey || 'all') === key;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    }

    #applyFilter(key) {
      for (const post of this.posts) {
        // Posts can have multiple space-separated keys
        const postKeys = (post.dataset.sbcKey || '').split(/\s+/).filter(Boolean);
        const shouldShow = key === 'all' || postKeys.includes(key);

        post.hidden = !shouldShow;
      }
    }
  }

  (() => {
    const roots = document.querySelectorAll('.section-blog-custom-posts');
    for (const root of roots) new SectionBlogCustomPosts(root);
  })();

  } catch(e) { console.error(e); }
})();
})();
